
import { useLanguage } from "@/contexts/LanguageContext";
import MenuItem from "./MenuItem";
import { Home, Search, Star, User, ShieldCheck } from "lucide-react";
import { useSupabaseAuth } from "@/hooks/useSupabaseAuth";

interface NavigationSectionProps {
  onItemClick: () => void;
}

export default function NavigationSection({ onItemClick }: NavigationSectionProps) {
  const { t } = useLanguage();
  const { isAdmin } = useSupabaseAuth();
  
  return (
    <div className="mb-8">
      <h2 className="text-xl font-semibold mb-4">{t("nav.menu")}</h2>
      
      <nav className="space-y-2">
        <MenuItem 
          to="/" 
          icon={<Home className="h-5 w-5" />} 
          label={t("nav.home")}
          onClick={onItemClick}
        />
        <MenuItem 
          to="/find-places" 
          icon={<Search className="h-5 w-5" />} 
          label={t("nav.findPlaces")}
          onClick={onItemClick}
        />
        <MenuItem 
          to="/rate-place" 
          icon={<Star className="h-5 w-5" />} 
          label={t("nav.ratePlaces")}
          onClick={onItemClick}
        />
      </nav>
    </div>
  );
}
